import styled from "styled-components";

export const Container = styled.div`
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;

  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  min-height: 100vh;
  color: #fff;
  padding: 100px 50px 0px 50px;
  box-sizing: border-box;
  @media (max-width: 600px) {
    padding: 0;
    padding-top: 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const FormCard = styled.div`
  background: #303231ad;
  border-radius: 8px;
  padding: 24px;
  color: white;
  margin-bottom: 20px;

  @media (max-width: 600px) {
    overflow-y: auto;
    padding: 15px;
    border-radius: 5px;
    width: 90%;
  }
`;

export const FormTitle = styled.h2`
  margin: 0 0 20px 0;
  font-size: 20px;
  font-weight: 600;
  color: white;
  @media (max-width: 600px) {
    font-size: 18px;
  }
`;

export const FormField = styled.div`
  margin-bottom: 20px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #ccc;
  @media (max-width: 600px) {
    font-size: 12px;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid #444;
  border-radius: 4px;
  color: white;
  font-size: 14px;
  box-sizing: border-box;

  &::placeholder {
    color: #999;
  }

  &:focus {
    outline: none;
    border-color: #4caf50;
  }
  @media (max-width: 600px) {
    font-size: 12px;
    padding: 10px;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid #444;
  border-radius: 4px;
  color: white;
  font-size: 14px;
  min-height: 100px;
  resize: vertical;
  box-sizing: border-box;

  &::placeholder {
    color: #999;
  }

  &:focus {
    outline: none;
    border-color: #4caf50;
  }
  @media (max-width: 600px) {
    font-size: 12px;
    padding: 10px;
  }
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  @media (max-width: 600px) {
    gap: 10px;
  }
`;

export const RadioOption = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 0;

  input[type="radio"] {
    margin-right: 8px;
    accent-color: #4caf50;
  }

  span {
    font-size: 14px;
    color: white;
  }
`;

export const FileUpload = styled.div`
  border: 2px dashed #444;
  border-radius: 4px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.3s ease;

  &:hover {
    border-color: #4caf50;
  }
`;

export const FileList = styled.div`
  margin-top: 16px;
`;

export const FileItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  margin-bottom: 8px;
  font-size: 14px;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  color: #ff6b6b;
  cursor: pointer;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;

  &:hover {
    background: rgba(255, 107, 107, 0.2);
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #444;
  @media (max-width: 600px) {
    flex-direction: column;
    gap: 10px;
    margin-top: 15px;
    padding-top: 15px;
  }
`;

export const Button = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
`;

export const CancelButton = styled(Button)`
  background: #666;
  color: white;

  &:hover {
    background: #777;
  }
`;

export const CreateButton = styled(Button)`
  background: #4caf50;
  color: white;

  &:hover {
    background: #45a049;
  }
`;
